
let pageInitialized = false;

document.addEventListener("DOMContentLoaded",function(){
    if(pageInitialized) return; // Prevent double DOM load in Storybook
    pageInitialized = true;

    // Toggle Submenus
    const dropdownButton = document.querySelectorAll('.usa-nav__submenu-item > .usa-accordion__button');

    dropdownButton.forEach(el => {

        el.addEventListener('click', function(e) {
            e.stopPropagation(); // Prevent submenu from closing parent caused by USWDS hideActiveNavDropdown();

            const submenu = document.getElementById(this.getAttribute('aria-controls'));
            this.setAttribute('aria-expanded', this.getAttribute('aria-expanded') == "false" ? "true" : "false" );
            submenu.hidden = submenu.hidden ? false : true;
        });

        return false;
    });
});